import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import { languageLabels, supportedLanguages } from "i18n";

function LanguageSwitcher({ light }) {
  const { i18n, t } = useTranslation();
  const language = i18n.resolvedLanguage || "en";

  return (
    <FormControl size="small" variant="standard" sx={{ minWidth: 100, mr: 1 }}>
      <InputLabel
        id="language-switcher-label"
        sx={{ color: light ? "white" : undefined, "&.Mui-focused": { color: "inherit" } }}
      >
        {t("language")}
      </InputLabel>
      <Select
        labelId="language-switcher-label"
        value={language}
        label={t("language")}
        onChange={(event) => i18n.changeLanguage(event.target.value)}
        sx={{
          color: light ? "white" : undefined,
          "&:before": { borderBottomColor: light ? "rgba(255,255,255,0.7)" : undefined },
          "&:after": { borderBottomColor: light ? "white" : undefined },
          "& .MuiSvgIcon-root": { color: light ? "white" : undefined },
        }}
      >
        {supportedLanguages.map((code) => (
          <MenuItem key={code} value={code}>
            {languageLabels[code] || code}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

LanguageSwitcher.defaultProps = {
  light: false,
};

LanguageSwitcher.propTypes = {
  light: PropTypes.bool,
};

export default LanguageSwitcher;
